package com.vizio.redwolf.auth.api

import com.vizio.redwolf.auth.model.ApiFileLogResult

actual object ApiFileLogger {

    actual var logLevel: String? = null

    actual fun writeToFile(content: String): ApiFileLogResult {
        // No-op implementation
        return ApiFileLogResult.Success()
    }

    actual fun doInit(fileFullPath: String, fileMaxSizeInBytes: ULong, fileTrimSizeInBytes: ULong, apiFileLoggerLogLevel: String): ApiFileLogResult {
        // no-op
        return ApiFileLogResult.Success()
    }
}